Fundu.Pages.Loan = (function($, nv) {

    // Properties
    ///////////////////////////
    // Private Methods
    ///////////////////////////
    var selectElements = function() {
    }

    var initializeComponents = function(){
        $('.guarantee.show').on("click", function(ev){
            if(ev)
                ev.preventDefault();

            $(this).removeClass('show');
            $("#guarantee .hide").removeClass('hide').css('height', '');
        });

        $('#select-profile-invest').on('changed.bs.select', function (e, clickedIndex, newValue, oldValue) {
            // Move to formats.js
            var profileInvestments = $(this[clickedIndex]).data('invested');
            if(profileInvestments){
                var investedValue = parseInt(profileInvestments).toFixed(2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ");
                $("#amount-invested .value").text(investedValue);
                $("#amount-invested .currency").removeClass('hide');
            }
        });
    }

    // Init
    ///////////////////////////

    var initialize = function() {
        initializeComponents();

        Fundu.Components.Diagram.init();

        return $.Deferred().resolve(true);
    }

    var finalize = function() {

    }

    // Reveal public methods
    return {
        init: initialize,
        finalize: finalize
    }

})(jQuery);
